import Axios from 'axios'
import Vue from 'vue';
import i18n from '../../i18n';
import { API_HOST } from '../../config/app-const';
import { setAccessToken } from "../../mixins/insight/setAccessToken";

const state = {
  queries: {
    isBusy: false,
    data: null,
    error: null
  }
};

const mutations = {
  LOAD_QUERIES_BUSY: (state, payload) => {
    state.queries.isBusy = payload;
  },
  LOAD_QUERIES_SUCCESS: (state, payload) => {
    state.queries.isBusy = false;
    state.queries.data = payload;
    state.queries.error = null;
  },
  LOAD_QUERIES_FAIL: (state, payload) => {
    state.queries.isBusy = false;
    state.queries.error = payload;
  },
  DELETE_QUERY_SUCCESS(state, payload) {
    state.queries.data.data.data = state.queries.data.data.data.filter(query => query.id !== payload.data.id)
    state.queries.error = null;
  },
  RESET_PAGINATION: (state) => {
    state.queries.data = null;
  }
};

const actions = {
  getQueries: ({ commit, rootState }, { projectId, pagination, folderId }) => {
    commit('LOAD_QUERIES_BUSY', true);

    const config = {
      headers: { Authorization: setAccessToken(rootState) }
    };

    let query = '';
    if(pagination) {
      query = '?';
      Object.keys(pagination).map((param, i) => {
          query += `${param}=${pagination[param]}${i !== Object.keys(pagination).length - 1 ? '&' : ''}`;
        }
      );
    }
    
    if(folderId)
      query = `${query ? query + '&' : '?'}folder_id=${folderId}`;

    Axios
      .get(`${API_HOST}/projects/${projectId}/queries${query}`, config)
      .then((response) => {
        let data = response.data;
        if(data.status.message === "OK"){
          if(pagination && pagination.page > 1){
            const queries = state.queries.data.data.data;
            data = {
              data: {
                ...data.data,
                data: [
                  ...queries,
                  ...data.data.data
                ]
              }
            }
          }
          commit('LOAD_QUERIES_SUCCESS', data)
        }
        else{
          throw new Error(data.status.message)
        }
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('LOAD_QUERIES_FAIL', error)
      })
  },

  deleteQuery: ({ commit, rootState }, { projectId, queryId }) => {
    commit('LOAD_QUERIES_BUSY', true);

    const config = {
      headers: { Authorization: setAccessToken(rootState) }
    };

    Axios
      .delete(`${API_HOST}/projects/${projectId}/queries/${queryId}`, config)
      .then((response) => {
        commit('DELETE_QUERY_SUCCESS', response.data)
        Vue.notify({
          group: 'store_notifications',
          type: 'success',
          text: i18n.t('messages.queries.delete_success')});
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('LOAD_QUERIES_FAIL', error)
      })
      .finally(() => commit('LOAD_QUERIES_BUSY', false));
  },
  resetPagination({ commit }) {
    commit('RESET_PAGINATION'); 
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};